import { ParsedWebp } from './parse-webp';

/**
 * 애니메이션 WebP 파싱 결과를 캐싱한다.
 * @remotion/gif의 volatileGifCache (QuickLRU) 패턴을 따름.
 *
 * 완료된 파싱 결과만 캐싱하여 동일 src에 대한 반복 파싱을 방지한다.
 */
const MAX_CACHE_SIZE = 30;

const cache = new Map<string, ParsedWebp>();
const accessOrder: string[] = [];

const evictIfNeeded = () => {
  while (cache.size > MAX_CACHE_SIZE && accessOrder.length > 0) {
    const oldest = accessOrder.shift()!;
    cache.delete(oldest);
  }
};

const touch = (key: string) => {
  const idx = accessOrder.indexOf(key);
  if (idx !== -1) {
    accessOrder.splice(idx, 1);
  }
  accessOrder.push(key);
};

export const getWebpFromCache = (src: string): ParsedWebp | undefined => {
  const cached = cache.get(src);
  if (cached) {
    touch(src);
  }
  return cached;
};

export const setWebpToCache = (src: string, parsed: ParsedWebp): void => {
  cache.set(src, parsed);
  touch(src);
  evictIfNeeded();
};
